/**
 * Pending multi-workspace RAG scope for New Chat (no threadId yet).
 * Applied via ragScopeService.setThreadScope once the thread is created.
 */

import { normalizeRagScope } from "@/lib/ragScopePure";

let pendingWorkspaceIds: string[] | null = null;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((l) => l());
}

export function getPendingRagScope(): string[] | null {
  return pendingWorkspaceIds ? [...pendingWorkspaceIds] : null;
}

export function setPendingRagScope(ids: string[] | null): void {
  if (!ids || ids.length === 0) {
    pendingWorkspaceIds = null;
  } else {
    pendingWorkspaceIds = normalizeRagScope(ids);
  }
  notify();
}

export function clearPendingRagScope(): void {
  pendingWorkspaceIds = null;
  notify();
}

export function subscribePendingRagScope(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Consume pending scope for a newly created thread (clears store). */
export function takePendingRagScope(): string[] | null {
  const next = pendingWorkspaceIds ? [...pendingWorkspaceIds] : null;
  pendingWorkspaceIds = null;
  notify();
  return next;
}
